import { render, staticRenderFns } from "./ProductoEdit.vue?vue&type=template&id=491f900c&scoped=true&"
import script from "./ProductoEdit.vue?vue&type=script&lang=js&"
export * from "./ProductoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491f900c",
  null
  
)

export default component.exports